import { useState } from "react";
import { Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import ResultTable from "../Results/ResultTable";
import { formatDate } from "../../Utilities/dateUtils";
import {
  GetResultsByProgramId,
  GetTeacherInformation,
} from "../../actions/teacherQueries";
import { PacmanLoader } from "react-spinners";
import { compareByName } from "../../Utilities/sortHelper";

export default function ProgramResultOverview(props) {
  const coursesData = GetResultsByProgramId(props.programId);
  const teacherInfo = GetTeacherInformation();
  const [showAllClasses, setShowAllClasses] = useState(false);

  let columnExtensions = [
    { columnName: "name", width: 260 },
    { columnName: "avgScore", width: 250 },
    { columnName: "avgPercDone", width: 250 },
    { columnName: "avgNumTries", width: 250 },
    { columnName: "avgActivityPoints", width: 260 },
    { columnName: "lastRun", width: 180 },
  ];

  let columns = [
    { title: <FormattedMessage id="Name" />, name: "name" },
    { title: <FormattedMessage id="avgModuleTestScore" />, name: "avgScore" },
    { title: <FormattedMessage id="avgPercDone" />, name: "avgPercDone" },
    { title: <FormattedMessage id="avgNumTries" />, name: "avgNumTries" },
    {
      title: <FormattedMessage id="avgActivityPoints" />,
      name: "avgActivityPoints",
    },
    { title: <FormattedMessage id="LastRun" />, name: "lastRun" },
  ];

  if (!coursesData || coursesData.isPending || !coursesData.data) {
    return (
      <div className="inline-pacman-loader">
        <PacmanLoader color="#20a8d8" size={20} />
      </div>
    );
  }

  const isHidden = (classRes) =>
    teacherInfo.data?.hiddenClassIds?.includes(classRes.id);
  const hiddenClassCount = new Set(
    coursesData.data
      .flatMap((course) => course.classes)
      .filter(isHidden)
      .map((classRes) => classRes.id),
  ).size;

  let resultTableData = [];

  coursesData.data.forEach((course) => {
    let courseToAdd = {
      name: course.courseName,
      id: "c" + course.id,
      parentId: null,
    };
    resultTableData.push(courseToAdd);
    const shownClasses = showAllClasses
      ? course.classes
      : course.classes.filter((classRes) => !isHidden(classRes));
    [...shownClasses].sort(compareByName).forEach((classRes) => {
      let classToAdd = {
        name: classRes.name,
        parentId: "c" + course.id,
        avgScore: classRes.averageScore,
        avgPercDone: classRes.donePercentage,
        avgNumTries: classRes.averageNumberOfTimes,
        avgActivityPoints: classRes.averageActivityPoints,
        lastRun:
          classRes.lastRun === null
            ? null
            : formatDate(classRes.lastRun, "PPp"),
      };
      resultTableData.push(classToAdd);
    });
  });

  return (
    <>
      {hiddenClassCount > 0 ? (
        <p className="mb-2">
          <FormattedMessage
            id="HiddenClassesInResults"
            values={{ count: hiddenClassCount }}
          />{" "}
          <Button
            color="link"
            className="p-0 align-baseline"
            onClick={() => setShowAllClasses(!showAllClasses)}
          >
            <FormattedMessage
              id={showAllClasses ? "ShowOnlyMyClasses" : "ShowAll"}
            />
          </Button>
        </p>
      ) : (
        ""
      )}
      <ResultTable
        level="Class"
        tableData={resultTableData}
        columnExtensions={columnExtensions}
        columns={columns}
        rightAlignedColumns={[
          "avgScore",
          "avgPercDone",
          "avgNumTries",
          "avgActivityPoints",
        ]}
      />
    </>
  );
}
